import defaultClient from '@/plugins/axios/defaultClient'

export default {
  /**
   * 랜딩페이지 가심사 한도 조회
   * @param {*} credentials
   * @returns
   */
  postCrowdFundingReview(credentials) {
    return defaultClient.post(`/crowd-funding/review/`, credentials)
  },

  /**
   * 상담신청
   * (랜딩페이지 가심사 한도 조회 후)
   *
   * @param {*} credentials
   * @returns
   */
  postCrowdFundingRequest(form) {
    return defaultClient.post(`/crowd-funding/requests/`, form)
  },
}
